import _ from 'lodash';
import { EventEmitter } from 'events';
import AppDispatcher from '../dispatcher/AppDispatcher';
import BankTransferConstants from '../constants/BankTransferConstants';

let _status = {};
let _requests = {};
let _progress = {};

const BankTransferStore = _.extend({}, EventEmitter.prototype, {
	getStatus: function (booking_id) {
		return _status[booking_id] || BankTransferConstants.STATUS.INITIAL;
	},

	getRequest: function (booking_id) {
		return _requests[booking_id] || null;
	},

	getProgress: function (booking_id) {
		return _progress[booking_id] || 0;
	},

	emitChange: function () {
		this.emit('change');
	},

	addChangeListener: function (callback) {
		this.on('change', callback);
	},

	removeChangeListener: function (callback) {
		this.removeListener('change', callback);
	},
});

AppDispatcher.register(function (payload) {
	let action = payload.action;

	switch (action.actionType) {
		case BankTransferConstants.BANK_TRANSFER_LOADING:
			_status[action.data.booking_id] = BankTransferConstants.STATUS.BUSY;
			_progress[action.data.booking_id] = 0;
			break;

		case BankTransferConstants.BANK_TRANSFER_PROGRESS:
			_progress[action.data.booking_id] = action.data.progress;
			break;

		case BankTransferConstants.BANK_TRANSFER_SUCCESS:
			_status[action.data.booking_id] = BankTransferConstants.STATUS.SUCCESS;
			if (action.data.request) {
				_requests[action.data.booking_id] = action.data.request;
			}
			break;

		case BankTransferConstants.BANK_TRANSFER_FAILED:
			_status[action.data.booking_id] = BankTransferConstants.STATUS.FAILED;
			break;

		default:
			return true;
	}

	// If action was responded to, emit change event
	BankTransferStore.emitChange();

	return true;
});

export default BankTransferStore;
